import { getWindowLocationHrefImplementation } from './restricted/location';

/**
 * Navigates the page, equivalent to `window.location.href = value`. Use this
 * instead of assigning to `window.location.href` directly so frameworks like
 * Granite can turn the navigation into an in-page app transition.
 */
export function setWindowLocationHref(value) {
  getWindowLocationHrefImplementation()(value);
}